import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=8c2cacfa&scoped=true"
import script from "./pageFooter.vue?vue&type=script&lang=js"
export * from "./pageFooter.vue?vue&type=script&lang=js"
import style0 from "./pageFooter.vue?vue&type=style&index=0&id=8c2cacfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2cacfa",
  null
  
)

export default component.exports